import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MaiaPublicHeader from '../components/common/MaiaPublicHeader';
import MaiaPublicFooter from '../components/common/MaiaPublicFooter';
import { FONT_HREF, FONT_ID } from '../support/maiaFonts';
import '../styles/maia-landing.css';

function MaiaPublicLayout() {
  useEffect(() => {
    const previous = document.getElementById('maia-landing-fonts');
    if (previous) previous.remove();

    if (document.getElementById(FONT_ID)) return undefined;
    const link = document.createElement('link');
    link.id = FONT_ID;
    link.rel = 'stylesheet';
    link.href = FONT_HREF;
    document.head.appendChild(link);
    return undefined;
  }, []);

  return (
    <div className="maia-shell maia-landing">
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div
          className="absolute -top-32 left-1/2 h-[42rem] w-[42rem] -translate-x-1/2 rounded-full opacity-70"
          style={{
            background:
              'radial-gradient(circle, rgba(13,115,119,0.14) 0%, transparent 68%)',
          }}
        />
        <div
          className="absolute bottom-0 right-0 h-[28rem] w-[28rem] rounded-full opacity-50"
          style={{
            background:
              'radial-gradient(circle, rgba(20,17,15,0.06) 0%, transparent 70%)',
          }}
        />
      </div>

      <MaiaPublicHeader />

      <main className="relative pt-16">
        <Outlet />
      </main>

      <MaiaPublicFooter />
    </div>
  );
}

export default MaiaPublicLayout;
